export default __webpack_public_path__ + "static/media/postgresql.ae92b576.svg";